import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _extends from 'babel-runtime/helpers/extends';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _defineProperty from 'babel-runtime/helpers/defineProperty';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Navbar, NavbarToggler, Collapse } from 'reactstrap';

import { listOrSingleSize } from './utils';

import NavigationBrand from './NavigationBrand';
import NavigationList from './NavigationList';
import NavigationContent from './NavigationContent';

//import './navigation.css';

var NAV_CONTAINER_CLASS = "navigation-container";
var NAV_CONTAINER_DISABLED_CLASS = "navigation-container-disabled";
var NAV_CONTAINER_SCROLL_NONE_CLASS = "navigation-container-scroll-none";
var NAV_CONTAINER_SCROLL_ALWAYS_CLASS = "navigation-container-scroll-always";
var NAV_CONTAINER_COLLAPSED_CLASS = "navigation-container-collapsed";
var NAV_CONTAINER_EXPANDED_CLASS = "navigation-container-expanded";
var NAV_BAR_EXPANDED_CLASS = "navbar-expand";
var NAV_MAIN_CONTAINER_CLASS = "navigation-main-container";

var BOOTSTRAP_DARK = 'dark';
var BOOTSTRAP_LIGHT = 'light';

function getBootstrapNavBarInverseProps(inverse) {
  var inverseKey = inverse ? BOOTSTRAP_DARK : BOOTSTRAP_LIGHT;
  return _defineProperty({
    color: inverseKey
  }, inverseKey, true);
}

function getSideNavClassName(inverse) {
  return inverse ? 'bg-dark' : 'bg-light';
}

var DEFAULT_ON_ITEM_CLICK = function DEFAULT_ON_ITEM_CLICK(item, contentRef) {
  return item.onClick && item.onClick(item, contentRef);
};
var DEFAULT_IS_ITEM_ACTIVE = function DEFAULT_IS_ITEM_ACTIVE(item) {
  return item.active === true;
};
var DEFAULT_IS_ITEM_STATUS = function DEFAULT_IS_ITEM_STATUS(item) {
  return item.status === true;
};
var DEFAULT_FORMAT_ITEM_PATH = function DEFAULT_FORMAT_ITEM_PATH(path) {
  return path;
};
var DEFAULT_IS_ITEM_COLLAPSE_FILTERED = function DEFAULT_IS_ITEM_COLLAPSE_FILTERED(item, collapsed) {
  return item.collapsed === void 0 || item.collapsed === collapsed;
};
var DEFAULT_IS_ITEM_FILTERED = function DEFAULT_IS_ITEM_FILTERED(item) {
  return true;
};

var EMPTY_ITEMS = [];

var EMPTY_STATE = {
  collapsedMenuOpen: false,
  userPrimaryGroupId: void 0,
  userSecondaryGroupId: void 0
};

var Navigation = function (_PureComponent) {
  _inherits(Navigation, _PureComponent);

  function Navigation(props) {
    _classCallCheck(this, Navigation);

    var _this = _possibleConstructorReturn(this, (Navigation.__proto__ || Object.getPrototypeOf(Navigation)).call(this, props));

    _this.setContentRef = function (ref) {
      _this._contentRef = ref;
    };

    _this.onBrandItemClick = function (brandItem) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onBrandItemClick = _this$props.onBrandItemClick;

      if (!disabled) {
        onBrandItemClick(brandItem, _this._contentRef);
      }
    };

    _this.onItemClick = function (item) {
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          onItemClick = _this$props2.onItemClick;

      if (!disabled) {
        onItemClick(item, _this._contentRef);
      }
    };

    _this.onPrimaryGroupClick = function (_ref2, contentRef) {
      var id = _ref2.id;

      _this.setState({ userPrimaryGroupId: _this.state.userPrimaryGroupId === id ? null : id });
    };

    _this.onSecondaryGroupClick = function (_ref3, contentRef) {
      var id = _ref3.id;

      _this.setState({ userSecondaryGroupId: _this.state.userSecondaryGroupId === id ? null : id });
    };

    _this.onCollapsedMenuToggleClick = function () {
      _this.setState({ collapsedMenuOpen: !_this.state.collapsedMenuOpen });
    };

    _this._contentRef = null;
    _this.state = _extends({}, EMPTY_STATE);
    return _this;
  }

  _createClass(Navigation, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var path = nextProps.path;

      if (path !== this.props.path) {
        this.setState(EMPTY_STATE);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          stripB = _props.brandItem,
          stripPL = _props.primaryLeftItems,
          stripPR = _props.primaryRightItems,
          stripS = _props.secondaryItems,
          content = _props.content,
          className = _props.className,
          scrollContent = _props.scrollContent,
          inverse = _props.inverse,
          disabled = _props.disabled,
          collapsed = _props.collapsed,
          activePrimaryGroupId = _props.activePrimaryGroupId,
          activeSecondaryGroupId = _props.activeSecondaryGroupId,
          openActivePrimaryGroup = _props.openActivePrimaryGroup,
          openActiveSecondaryGroup = _props.openActiveSecondaryGroup,
          onBrandItemClick = _props.onBrandItemClick,
          onItemClick = _props.onItemClick,
          onPrimaryGroupClick = _props.onPrimaryGroupClick,
          onSecondaryGroupClick = _props.onSecondaryGroupClick,
          onCollapsedMenuToggleClick = _props.onCollapsedMenuToggleClick,
          isBrandItemActive = _props.isBrandItemActive,
          isItemActive = _props.isItemActive,
          isItemFiltered = _props.isItemFiltered,
          isItemCollapseFiltered = _props.isItemCollapseFiltered,
          isItemStatus = _props.isItemStatus,
          otherProps = _objectWithoutProperties(_props, ['brandItem', 'primaryLeftItems', 'primaryRightItems', 'secondaryItems', 'content', 'className', 'scrollContent', 'inverse', 'disabled', 'collapsed', 'activePrimaryGroupId', 'activeSecondaryGroupId', 'openActivePrimaryGroup', 'openActiveSecondaryGroup', 'onBrandItemClick', 'onItemClick', 'onPrimaryGroupClick', 'onSecondaryGroupClick', 'onCollapsedMenuToggleClick', 'isBrandItemActive', 'isItemActive', 'isItemFiltered', 'isItemCollapseFiltered', 'isItemStatus']);

      var _state = this.state,
          userPrimaryGroupId = _state.userPrimaryGroupId,
          userSecondaryGroupId = _state.userSecondaryGroupId,
          collapsedMenuOpen = _state.collapsedMenuOpen;
      var _props2 = this.props,
          brandItem = _props2.brandItem,
          primaryLeftItems = _props2.primaryLeftItems,
          primaryRightItems = _props2.primaryRightItems,
          secondaryItems = _props2.secondaryItems;


      var containerClasses = [NAV_CONTAINER_CLASS, collapsed ? NAV_CONTAINER_COLLAPSED_CLASS : NAV_CONTAINER_EXPANDED_CLASS];
      if (disabled) {
        containerClasses.push(NAV_CONTAINER_DISABLED_CLASS);
      }
      if (scrollContent === false) {
        containerClasses.push(NAV_CONTAINER_SCROLL_NONE_CLASS);
      } else if (scrollContent === true) {
        containerClasses.push(NAV_CONTAINER_SCROLL_ALWAYS_CLASS);
      }
      if (className) {
        containerClasses.push(className);
      }
      var containerClass = containerClasses.join(' ');

      var navBarClass = collapsed ? null : NAV_BAR_EXPANDED_CLASS;

      var hasSecondaryNav = listOrSingleSize(secondaryItems) > 0;

      var commonProps = _extends({}, otherProps, {
        collapsed: collapsed,
        disabled: disabled
      });

      var isItemNotStatus = function isItemNotStatus(item) {
        return !isItemStatus(item);
      };
      var isFiltered = function isFiltered(item) {
        return isItemFiltered(item) && isItemCollapseFiltered(item, collapsed);
      };

      brandItem = brandItem && isFiltered(brandItem) ? brandItem : null;
      primaryLeftItems = primaryLeftItems ? primaryLeftItems.filter(isFiltered) : EMPTY_ITEMS;
      primaryRightItems = primaryRightItems ? primaryRightItems.filter(isFiltered) : EMPTY_ITEMS;
      secondaryItems = secondaryItems ? secondaryItems.filter(isFiltered) : EMPTY_ITEMS;

      var statusLeftItems = collapsed && primaryLeftItems ? primaryLeftItems.filter(isItemStatus) : void 0;
      var statusRightItems = collapsed && primaryRightItems ? primaryRightItems.filter(isItemStatus) : void 0;
      var nonStatusLeftItems = collapsed && primaryLeftItems ? primaryLeftItems.filter(isItemNotStatus) : primaryLeftItems;
      var nonStatusRightItems = collapsed && primaryRightItems ? primaryRightItems.filter(isItemNotStatus) : primaryRightItems;

      var brandProps = _extends({}, commonProps, {
        brandItem: brandItem,
        isBrandItemActive: isBrandItemActive,
        onBrandItemClick: this.onBrandItemClick
      });

      var brand = React.createElement(NavigationBrand, brandProps);

      var toggler = React.createElement(NavbarToggler, { onClick: this.onCollapsedMenuToggleClick });

      var mainLeft = false;
      var mainRight = false;
      if (brandItem) {
        mainLeft = brandItem.pullRight !== true ? brand : toggler;
        mainRight = brandItem.pullRight === true ? brand : toggler;
      } else {
        mainRight = toggler;
      }

      var inverseProps = getBootstrapNavBarInverseProps(inverse);
      var sideNavClassName = getSideNavClassName(inverse);

      var listProps = _extends({}, commonProps, {
        isItemActive: isItemActive,
        onItemClick: this.onItemClick
      });

      var openPrimaryGroupId = userPrimaryGroupId === void 0 ? openActivePrimaryGroup(this.props) ? activePrimaryGroupId : void 0 : userPrimaryGroupId;
      var openSecondaryGroupId = userSecondaryGroupId === void 0 ? openActiveSecondaryGroup(this.props) ? activeSecondaryGroupId : void 0 : userSecondaryGroupId;

      return React.createElement(
        'div',
        { className: containerClass },
        React.createElement(
          Navbar,
          _extends({}, inverseProps, { fixed: 'top', role: 'navigation', className: navBarClass }),
          React.createElement(
            'div',
            { className: NAV_MAIN_CONTAINER_CLASS },
            mainLeft,
            React.createElement(NavigationList, _extends({}, listProps, { isPrimary: true, isDropdown: true, pullRight: false, items: statusLeftItems, openGroupId: openPrimaryGroupId,
              onGroupClick: this.onPrimaryGroupClick })),
            React.createElement(NavigationList, _extends({}, listProps, { isPrimary: true, isDropdown: true, pullRight: true, items: statusRightItems, openGroupId: openPrimaryGroupId,
              onGroupClick: this.onPrimaryGroupClick })),
            mainRight
          ),
          React.createElement(
            Collapse,
            { isOpen: collapsedMenuOpen, navbar: true },
            React.createElement(NavigationList, _extends({}, listProps, { isPrimary: true, isDropdown: !collapsed, pullRight: false, items: nonStatusLeftItems, openGroupId: openPrimaryGroupId,
              onGroupClick: this.onPrimaryGroupClick })),
            React.createElement(NavigationList, _extends({}, listProps, { isPrimary: true, isDropdown: !collapsed, pullRight: true, items: nonStatusRightItems, openGroupId: openPrimaryGroupId,
              onGroupClick: this.onPrimaryGroupClick })),
            React.createElement(NavigationList, _extends({}, listProps, { isPrimary: false, isDropdown: false, className: sideNavClassName, items: secondaryItems, openGroupId: openSecondaryGroupId,
              onGroupClick: this.onSecondaryGroupClick }))
          )
        ),
        React.createElement(
          NavigationContent,
          { hasSecondaryNav: hasSecondaryNav, ref: this.setContentRef },
          content
        )
      );
    }
  }, {
    key: 'checkRefsLoaded',
    value: function checkRefsLoaded() {
      if (!this.state.refsLoaded && this._contentRef) {
        this.setState({ refsLoaded: true });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.checkRefsLoaded();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.checkRefsLoaded();
    }
  }]);

  return Navigation;
}(PureComponent);

Navigation.propTypes = {
  path: PropTypes.string,
  brandItem: PropTypes.object,
  primaryLeftItems: PropTypes.array,
  primaryRightItems: PropTypes.array,
  secondaryItems: PropTypes.array,
  content: PropTypes.any,
  className: PropTypes.string,
  scrollContent: PropTypes.bool,
  inverse: PropTypes.bool,
  disabled: PropTypes.bool,
  collapsed: PropTypes.bool,
  activePrimaryGroupId: PropTypes.any,
  activeSecondaryGroupId: PropTypes.any,
  openActivePrimaryGroup: PropTypes.func,
  openActiveSecondaryGroup: PropTypes.func,
  onBrandItemClick: PropTypes.func,
  onItemClick: PropTypes.func,
  isBrandItemActive: PropTypes.func,
  isItemActive: PropTypes.func,
  isItemFiltered: PropTypes.func,
  isItemCollapseFiltered: PropTypes.func,
  isItemStatus: PropTypes.func,
  formatItemPath: PropTypes.func,
  groupIcon: PropTypes.any,
  groupOpenedIcon: PropTypes.any,
  groupClosedIcon: PropTypes.any
};
Navigation.defaultProps = {
  inverse: false,
  disabled: false,
  collapsed: false,
  openActivePrimaryGroup: function openActivePrimaryGroup(_ref4) {
    var collapsed = _ref4.collapsed;
    return collapsed;
  },
  openActiveSecondaryGroup: function openActiveSecondaryGroup(props) {
    return true;
  },
  onBrandItemClick: DEFAULT_ON_ITEM_CLICK,
  onItemClick: DEFAULT_ON_ITEM_CLICK,
  isBrandItemActive: DEFAULT_IS_ITEM_ACTIVE,
  isItemActive: DEFAULT_IS_ITEM_ACTIVE,
  isItemFiltered: DEFAULT_IS_ITEM_FILTERED,
  isItemCollapseFiltered: DEFAULT_IS_ITEM_COLLAPSE_FILTERED,
  isItemStatus: DEFAULT_IS_ITEM_STATUS,
  formatItemPath: DEFAULT_FORMAT_ITEM_PATH
};
export default Navigation;